import { Routes as ReactRoutes, Route, Navigate } from "react-router-dom";
import PageAI from "../pages/ai/PageAI";
import PageAddressbook from "../pages/addressbook/PageAddressbook";
import PageProperties from "../pages/properties/PageProperties";
import PageMatch from "../pages/match/PageMatch";
import PageCampaigns from "../pages/campaigns/PageCampaigns";
import PageDeals from "../pages/deals/PageDeals";
import PageLoanInbox from "../pages/loans/PageLoanInbox";
import PageFeedback from "../pages/feedback/PageFeedback";
import PageFiles from "../pages/files/PageFiles";
import PageToDo from "../pages/todo/PageToDo";
import PageJournal from "../pages/journal/PageJournal";
import PageLLMChat from "../pages/llmchat/PageLLMChat";

const Routes = () => (
  <ReactRoutes>
    <Route path="/ai" element={<PageAI />} />
    <Route path="/addressbook" element={<PageAddressbook />} />
    <Route path="/properties" element={<PageProperties />} />
    <Route path="/match" element={<PageMatch />} />
    <Route path="/campaigns" element={<PageCampaigns />} />
    <Route path="/deals" element={<PageDeals />} />
    <Route path="/loans" element={<PageLoanInbox />} />
    <Route path="/feedback" element={<PageFeedback />} />
    <Route path="/files" element={<PageFiles />} />
    <Route path="/todo" element={<PageToDo />} />
    <Route path="/journal" element={<PageJournal />} />
    <Route path="/aichat" element={<PageLLMChat />} />
    <Route path="*" element={<Navigate to="/ai" replace />} />
  </ReactRoutes>
);

export default Routes;
